<!-- Template -->
<template>  
    <Layout :path="path" :hospital="hospital" :hospitals="hospitals" :section="'activity'">
        <ActivityHeader />                                                
        <ActivityNavigation />
        <ActivityContent :hospital="hospital" />  
    </Layout>     
</template>
<!-- Script -->
<script>
    import '@/prototypes/array';
    import { HospitalService } from '@/services/hospital-service';

    import Layout from '@/layouts/Default';

    import ActivityHeader from '@/components/Activity/Header';
    import ActivityNavigation from '@/components/Activity/Navigation';
    import ActivityContent from '@/components/Activity/Content';

    export default {
        name: 'Activity',

        components: {
            Layout,
            ActivityHeader,
            ActivityNavigation,
            ActivityContent
        },

        data() {
             return {           
                params: {
                    hospital: null
                },     
                hospital: null,
                hospitals: [],
                path:[]
            }
        },

        watch: {
			'$route' (to) {
                this.params.hospital = +to.params.hospital;                
				this.update();
			}
		},

        created() {                                 
            this.params.hospital = +this.$route.params.hospital;
            this.hospitalService = new HospitalService(this.$api, this.$store);  
        },

        async mounted() {
            this.hospitals = await this.hospitalService.list();
            this.update();       
        },

        methods: {
            update() { 
                this.hospital = this.hospitals.findById(this.params.hospital);

                this.path = [];
                this.path.push(
                    {name:this.hospital.locationName, last:false, path:'/hospitals/' + this.params.hospital},
                    {name:'Activity Feed', last:true, path:'/hospitals/' + this.params.hospital + '/activity'}
                ); 
            }
        }
    }
</script>